import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import shape1 from '../../images/shape/line-shape03.png'
import shape2 from '../../images/shape/line-shape04.png'
import shape3 from '../../images/shape/pattern02.png'
import shape4 from '../../images/shape/monitor-shape.png'
import shape5 from '../../images/shape/blur-shape.png'

const RoadmapSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const roadmapData = [
        {
            quarter: "01",
            year: "2015",
            title: "Bogin Tech was founded",
            content:
                "A small team of engineers set out with one mission: build software that solves real business problems. Our first custom platforms proved that thoughtful engineering drives measurable results.",
        },
        {
            quarter: "02",
            year: "2017",
            title: "Expanded into cloud & DevOps",
            content:
                "As clients scaled, so did we. We embraced cloud-native architecture and DevOps automation, helping businesses ship faster, cut infrastructure costs, and stay reliably online.",
        },
        {
            quarter: "03",
            year: "2019",
            title: "AI & data engineering practice launched",
            content:
                "We added AI, machine learning, and data engineering to our toolkit—turning raw data into predictive insight and intelligent automation for enterprises and startups alike.",
        },
        {
            quarter: "04",
            year: "2021",
            title: "Security-first delivery at scale",
            content:
                "With cyber threats rising, we made security a first-class part of every build—embedding modern security frameworks, compliance, and resilience into the software we deliver.",
        },
        {
            quarter: "05",
            year: "2023",
            title: "Trusted across 15+ industries",
            content:
                "From healthcare and finance to retail, logistics, and education, our solutions now power organizations worldwide—delivering scalable, secure, and intelligent digital products.",
        },
        {
            quarter: "06",
            year: "2025",
            title: "Architecting intelligent futures",
            content:
                "Today, Bogin Tech is a full-stack technology partner—uniting AI, cloud, custom software, and cybersecurity to help businesses innovate, transform, and lead in their markets.",
        },
        {
            quarter: "07",
            year: "Next",
            title: "Building what's next, with you",
            content:
                "Whether you need your first digital product or enterprise-scale transformation, we bring the expertise and partnership to turn your vision into reality.",
        },
    ];

    return (
        <section className="roadmap roadmap-pb pt-130 pb-200 pos-rel" style={{ backgroundColor: "#0F55DC" }}>
            <div className="container">
                <div className="sa-tes_top roadmap-top pos-rel mb-85">
                    <div className="sec-title--two">
                        <div className="sub-title sub-title--strock wow fadeInDown" data-wow-duration="600ms"><img src="assets/img/icon/process-icon.svg" alt="" />Our Journey</div>
                        <h2 className="title clr-white wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">A Decade of Engineering Impact</h2>
                    </div>
                    <div className="sa-tes_button roadmap-button">
                        <div className="sa-swiper-btn swiper-button-prev" ref={prevRef}><i className="fal fa-angle-left"></i></div>
                        <div className="sa-swiper-btn active swiper-button-next" ref={nextRef}><i className="fal fa-angle-right"></i></div>
                    </div>
                </div>
            </div>
            <div className="roadmap-slider-container">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    loop={true}
                    spaceBetween={50}
                    speed={400}
                    slidesPerView={3}
                    centeredSlides={true}
                    autoplay={{
                        delay: 6000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        el: ".swiper-pagination",
                        clickable: true,
                    }}
                    navigation={{
                        nextEl: nextRef.current,
                        prevEl: prevRef.current,
                    }}
                    breakpoints={{
                        1600: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        576: {
                            slidesPerView: 1,
                        },
                        0: {
                            slidesPerView: 1,
                        },
                    }}
                    className="raodmap-slider"
                >
                    {roadmapData.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="roadmap-item">
                                <div className="xb-item--top">
                                    <img src={shape1} alt="" />
                                    <span className="xb-item--ques">{item.quarter}</span>
                                    <img src={shape2} alt="" />
                                </div>
                                <div className="xb-item--holder">
                                    <span className="xb-item--year">{item.year}</span>
                                    <h3 className="xb-item--title">{item.title}</h3>
                                    <p className="xb-item--content">{item.content}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Pagination */}
                <div className="swiper-pagination"></div>
            </div>
            <div className="roadmap-shape">
                <div className="shape shape--one"><img src={shape3} alt=""/></div>
                <div className="shape shape--two"><img src={shape4} alt=""/></div>
                <div className="shape shape--three"><img src={shape5} alt=""/></div>
            </div>
        </section>
    );
};

export default RoadmapSlider;
